import TextAlign from '@tiptap/extension-text-align';
import { Selection } from '@tiptap/extensions';
import StarterKit from '@tiptap/starter-kit';

import { AIHighlight } from './extensions/ai-highlight';
import { PreserveHeadingLevelOnEmpty } from './extensions/preserve-heading-level-on-empty';
import { Link } from './marks/link';
import { Image } from './nodes/image';
import { Table, TableCell, TableHeader, TableRow } from './nodes/table';

// Tiptap element styles are defined in base.css under the .tiptap class
export const starterKit = StarterKit.configure({
  code: false,
  codeBlock: false,
  dropcursor: false,
  gapcursor: false,
  trailingNode: false,
  // Replaced by our extended Link (marks/link.ts) carrying internalPageId.
  link: false,
});

export const link = Link.configure({
  openOnClick: false,
  autolink: true,
  // TipTap's enableClickSelection handler always claims clicks (extendMarkRange
  // returns true even off-link), which blocks caret placement / selection collapse.
  enableClickSelection: false,
  // Stock defaults force target="_blank" rel="noopener noreferrer nofollow" onto every
  // link; new-tab behavior is an explicit author choice in the link popover instead.
  HTMLAttributes: { target: null, rel: null },
});

// Keeps text visibly selected while a toolbar popover holds focus; styled in base.css.
const preservedSelection = Selection.configure({
  className: 'preserved-selection',
});

export const textAlign = TextAlign.configure({
  types: ['heading', 'paragraph'],
});

export const tableExtensions = [Table, TableRow, TableCell, TableHeader];

// Placeholder is configured in BaseEditableContent from the placeholder prop.
export const defaultExtensions = [
  starterKit,
  link,
  preservedSelection,
  Image,
  ...tableExtensions,
  textAlign,
  AIHighlight,
];

// Simple form fields (e.g. legal notices) skip the page-editor AI highlight mark.
export const richTextFieldExtensions = [starterKit, link, preservedSelection, textAlign];

const headingsOnlyStarterKit = StarterKit.configure({
  heading: { levels: [1, 2, 3, 4, 5, 6] },
  paragraph: false,
  hardBreak: false,
  bold: false,
  italic: false,
  strike: false,
  code: false,
  codeBlock: false,
  link: false,
  bulletList: false,
  orderedList: false,
  listItem: false,
  blockquote: false,
  horizontalRule: false,
  dropcursor: false,
  gapcursor: false,
  trailingNode: false,
});

export const headingsOnlyExtensions = [
  headingsOnlyStarterKit,
  PreserveHeadingLevelOnEmpty,
  AIHighlight,
];
